<script>
import Dialog from "primevue/dialog";
import ManagerCompanyInfoForm from "@/views/manager/ManagerCompanyInfoForm.vue";
import {mapActions, mapState} from "pinia";
import {managerStore} from "@/store/managerStore";
export default {
  name: "ManagerCompanyInfoModal",
  components: {
    Dialog,
    ManagerCompanyInfoForm
  },
  data() {
    return {
      saveBtnState: false
    }
  },
  computed: {
    ...mapState(managerStore, [
      'companyInfoModalState',
      'companyInfoModalParams'
    ]),
    modalState: {
      get() {
        return this.companyInfoModalState;
      },
      set() {
        this.closeModal();
      },
    },
    editModeState() {
      return this.companyInfoModalParams.editMode;
    },
    managerId() {
      return this.companyInfoModalParams.managerId;
    }
  },
  methods: {
    ...mapActions(managerStore, [
        'openCompanyInfoModal',
        'closeCompanyInfoModal'
    ]),
    closeModal() {
      this.closeCompanyInfoModal();
    },
    dataChanged() {
      this.saveBtnState = true;
    },
    saveCompanyInfo() {
      const companyInfoForm = this.$refs.managerCompanyInfoForm;

      if (companyInfoForm && this.saveBtnState) {
        companyInfoForm.saveInfo();
      }
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          modal
          :header="$t('companyInformation.managerCompanyInformation')"
          class="manager-company-information-modal"
  >
    <div>
      <manager-company-info-form :edit-mode="editModeState"
                                 :manager-id="managerId"
                                 ref="managerCompanyInfoForm"
                                 @on-save="closeModal()"
                                 @on-data-change="dataChanged()"
      />
    </div>
    <template #footer>
      <button v-if="editModeState"
              type="button"
              class="p-dialog-primary-btn"
              @click="saveCompanyInfo()"
              :class="{'disabled': !saveBtnState}"
      >{{$t('common.buttons.save')}}</button>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.cancel')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.manager-company-information-modal {
  min-width: 680px;
  .p-dialog-content {
    min-height: 220px;
    padding: 0 20px;
  }
}
</style>